if (!customElements.get('related-products')) {
    class RelatedProducts extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.style.minHeight = '37rem';
            this.style.display = 'block';
        }
    }

    customElements.define('related-products', RelatedProducts);
}